<template>
  <div class="products-list-card-wrapper">
    <div class="products-list-card-header">
      <span>{{ product.type || 'Atrativo' }}</span>
    </div>

    <div class="products-list-card">
      <div class="products-list-card-top">
        <div class="products-list-card-media">
          <b-img
            v-if="imageUrl"
            :src="imageUrl"
            fluid
            class="products-list-card-image"
          />
          <div class="products-list-card-title">
            <strong>{{ title }}</strong>
            <p v-if="product.description" class="products-list-card-desc">
              {{ product.description }}
            </p>
          </div>
        </div>

        <div class="products-list-card-actions">
          <button
            type="button"
            class="products-list-card-action"
            title="Editar atrativo"
            @click.stop="$emit('edit', product)"
          >
            <i class="fas fa-pen"></i>
          </button>

          <button
            type="button"
            class="products-list-card-action"
            title="QR Codes"
            @click.stop="$emit('qrcodes', product)"
          >
            <i class="fas fa-qrcode"></i>
          </button>

          <button
            type="button"
            class="products-list-card-action"
            title="Página de vendas"
            :disabled="!isActiveProduct"
            @click.stop="openSalesPage"
          >
            <i class="ni ni-world-2"></i>
          </button>

          <button
            type="button"
            class="products-list-card-action"
            :title="isVisible ? 'Reservas públicas' : 'Produto não visível'"
            :disabled="!isVisible"
            @click.stop="openPublicBookings"
          >
            <i :class="isVisible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
          </button>
        </div>
      </div>

      <div v-if="statsHtml" class="products-list-card-block">
        <strong class="text-blue">Estatísticas</strong>
        <div class="products-list-card-html" v-html="statsHtml"></div>
      </div>

      <div v-if="ticketsHtml" class="products-list-card-block">
        <strong class="text-blue">Ingressos</strong>
        <div class="products-list-card-html" v-html="ticketsHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductsListCard',

  props: {
    product: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: null,
    },
    statsHtml: {
      type: String,
      default: '',
    },
    ticketsHtml: {
      type: String,
      default: '',
    },
  },

  computed: {
    isActiveProduct() {
      const product = this.product
      if (!product) return false
      return (
        product.active === true ||
        product.active === 'true' ||
        product.active === 1
      )
    },

    isVisible() {
      const value = this.product && this.product.visibility
      return (
        value === true || value === 'true' || value === 1 || value === '1'
      )
    },
  },

  methods: {
    openSalesPage() {
      if (!this.isActiveProduct) return
      this.$emit('details', this.product)
    },

    openPublicBookings() {
      if (!this.isVisible) return
      this.$emit('public-bookings', this.product)
    },
  },
}
</script>

<style>
.products-list-card-wrapper {
  margin-bottom: 0.75rem;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e8eef1;
}

.products-list-card-header {
  padding: 0.4rem 0.85rem;
  background: #12576e;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.products-list-card {
  padding: 0.85rem;
}

.products-list-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.products-list-card-media {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  min-width: 0;
  flex: 1;
}

.products-list-card-image {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 6px;
  flex-shrink: 0;
}

.products-list-card-title {
  min-width: 0;
}

.products-list-card-desc {
  margin: 0.25rem 0 0;
  font-size: 0.85rem;
  color: #6b7280;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.products-list-card-actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
}

.products-list-card-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: 0;
  border-radius: 6px;
  background: #eef5f8;
  color: #12576e;
  cursor: pointer;
}

.products-list-card-action:hover {
  background: #d9ebf2;
}

.products-list-card-action:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.products-list-card-action:disabled:hover {
  background: #eef5f8;
}

.products-list-card-block {
  margin-top: 0.65rem;
  font-size: 0.85rem;
}

.products-list-card-html {
  margin-top: 0.25rem;
  color: #374151;
}
</style>
